export default __webpack_public_path__ + "static/media/header_books_xs.bcf0410e.png";